<template lang="pug">
  div
    get-part(v-model="modal" :current="current")
    template(v-if="current && current.extra")
      .absolute.inset-x-0.bottom-0.mb-20(class="lg:mb-24")
        .flex.justify-center.items-center
          .extra-thumbnail(v-for="ex in current.extra" @click="openExtra(ex)"
            :style="`background-image:url(${ex.imageSrc})`"
          )
      extra(v-model="extra" :extra="currentExtra")
</template>
<style lang="sass" scoped>
.extra-thumbnail
  @apply w-24 h-16 m-1 rounded bg-cover bg-center cursor-pointer border-2 border-bolt
</style>

<script>
import { mapGetters } from "vuex";
import GetPart from "@/components/stage/getPart";
import Extra from "@/components/stage/extra";
export default {
  components: {
    GetPart,
    Extra
  },
  computed: {
    ...mapGetters("stage", ["current"]),
    item() {
      if (!this.current) return 0;
      return this.$store.state.magrobo[this.current.part];
    }
  },
  data() {
    return {
      unWatchItem: null,
      modal: false,
      extra: false,
      currentExtra: null
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.onEnter(to.params.id);
    next();
  },
  mounted() {
    this.onEnter(this.$route.params.id);
  },
  beforeDestroy() {
    this.unWatchItem();
  },
  methods: {
    onEnter(id) {
      if (
        typeof DeviceOrientationEvent !== "undefined" &&
        DeviceOrientationEvent.requestPermission
      ) {
        DeviceOrientationEvent.requestPermission().then(permission => {
          this.$store.commit(
            "vr/deviceOrientationPermitted",
            permission === "granted"
          );
        });
      }
      this.$store.dispatch("stage/enter", id);
      this.unWatchItem = this.$watch("item", this.onGetItem);
    },
    onGetItem(value) {
      this.modal = value > 0;
      this.unWatchItem();
    },
    openExtra(extra) {
      this.extra = true;
      this.currentExtra = extra;
    }
  }
};
</script>
